__turbopack_context__.v({
  "className": "outfit_e5297ed6-module__AqNujW__className",
  "variable": "outfit_e5297ed6-module__AqNujW__variable",
});
